/**
 * The API's reply contracts as JSON Schema, written out from the zod in
 * packages/shared. Generated: do not edit. To regenerate after a contract
 * changes, run UPDATE_CONTRACTS=1 npx vitest run apps/web/test/contracts.test.ts
 * src/contract.ts has why these exist.
 */

import type { AccessError, AdminError, AiSettingResponse, AiSpendResponse, BillingResponse, CheckoutError, CheckoutResponse, CitationSourcesResponse, CiteResponse, CodeError, CompleteResponse, CreateProfileResponse, DecideAccessResponse, DeletionResponse, DocumentError, DocumentResponse, HistoryResponse, IntakeResponse, InternListResponse, KnowledgeError, KnowledgeHistoryResponse, KnowledgeSearchResponse, KnowledgeVersionsResponse, MeResponse, MyVoucherResponse, PendingListResponse, ProfileError, ProfileResponse, ProvisionInternsResponse, QuoteResponse, RecentsResponse, RedeemFirmCodeResponse, RemoveInternsResponse, RunResponse } from "@ls/shared";
import { contract } from "./contract";

export const POLICY_VERSION = "2026-09-26";

/** The admin site's batch of intern addresses, the same the API accepts. */
export const INTERN_BATCH = 40;

export const meResponseContract = contract<MeResponse>({
  "oneOf": [
    {
      "type": "object",
      "properties": {
        "ok": {
          "type": "boolean",
          "const": true
        },
        "state": {
          "type": "string",
          "const": "ready"
        },
        "profile": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "email": {
              "type": "string"
            },
            "emailVerifiedAt": {
              "anyOf": [
                {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
                },
                {
                  "type": "null"
                }
              ]
            },
            "name": {
              "type": [
                "string",
                "null"
              ]
            },
            "college": {
              "type": [
                "string",
                "null"
              ]
            },
            "programme": {
              "anyOf": [
                {
                  "type": "string",
                  "enum": [
                    "5_year",
                    "3_year"
                  ]
                },
                {
                  "type": "null"
                }
              ]
            },
            "year": {
              "anyOf": [
                {
                  "type": "string",
                  "enum": [
                    "1",
                    "2",
                    "3",
                    "4",
                    "5"
                  ]
                },
                {
                  "type": "null"
                }
              ]
            },
            "city": {
              "type": [
                "string",
                "null"
              ]
            },
            "consent": {
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "at": {
                      "type": "string",
                      "format": "date-time",
                      "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
                    },
                    "policyVersion": {
                      "type": "string"
                    },
                    "current": {
                      "type": "boolean"
                    }
                  },
                  "required": [
                    "at",
                    "policyVersion",
                    "current"
                  ],
                  "additionalProperties": false
                },
                {
                  "type": "null"
                }
              ]
            },
            "deletion": {
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "requestedAt": {
                      "type": "string",
                      "format": "date-time",
                      "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
                    },
                    "dueAt": {
                      "type": "string",
                      "format": "date-time",
                      "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
                    },
                    "reason": {
                      "type": "string",
                      "enum": [
                        "requested",
                        "plan_ended"
                      ]
                    }
                  },
                  "required": [
                    "requestedAt",
                    "dueAt",
                    "reason"
                  ],
                  "additionalProperties": false
                },
                {
                  "type": "null"
                }
              ]
            },
            "createdAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
            }
          },
          "required": [
            "id",
            "email",
            "emailVerifiedAt",
            "name",
            "college",
            "programme",
            "year",
            "city",
            "consent",
            "deletion",
            "createdAt"
          ],
          "additionalProperties": false
        },
        "plan": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "free",
                "firm",
                "annual"
              ]
            },
            "tier": {
              "anyOf": [
                {
                  "type": "string",
                  "enum": [
                    "base",
                    "premium",
                    "elite"
                  ]
                },
                {
                  "type": "null"
                }
              ]
            },
            "expiresAt": {
              "anyOf": [
                {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
                },
                {
                  "type": "null"
                }
              ]
            },
            "credits": {
              "type": "integer",
              "minimum": 0,
              "maximum": 9007199254740991
            }
          },
          "required": [
            "type",
            "tier",
            "expiresAt",
            "credits"
          ],
          "additionalProperties": false
        }
      },
      "required": [
        "ok",
        "state",
        "profile",
        "plan"
      ],
      "additionalProperties": false
    },
    {
      "type": "object",
      "properties": {
        "ok": {
          "type": "boolean",
          "const": true
        },
        "state": {
          "type": "string",
          "const": "awaiting_approval"
        },
        "email": {
          "type": "string"
        },
        "name": {
          "type": [
            "string",
            "null"
          ]
        }
      },
      "required": [
        "ok",
        "state",
        "email",
        "name"
      ],
      "additionalProperties": false
    },
    {
      "type": "object",
      "properties": {
        "ok": {
          "type": "boolean",
          "const": true
        },
        "state": {
          "type": "string",
          "const": "needs_profile"
        },
        "email": {
          "type": [
            "string",
            "null"
          ]
        }
      },
      "required": [
        "ok",
        "state",
        "email"
      ],
      "additionalProperties": false
    }
  ]
});

export const accessErrorContract = contract<AccessError>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": false
    },
    "error": {
      "type": "string",
      "enum": [
        "unauthenticated",
        "signed_in_elsewhere",
        "profile_required",
        "suspended",
        "awaiting_approval",
        "access_declined",
        "server_misconfigured"
      ]
    },
    "message": {
      "type": "string"
    }
  },
  "required": [
    "ok",
    "error",
    "message"
  ],
  "additionalProperties": false
});

export const profileResponseContract = contract<ProfileResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "profile": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "email": {
          "type": "string"
        },
        "emailVerifiedAt": {
          "anyOf": [
            {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
            },
            {
              "type": "null"
            }
          ]
        },
        "name": {
          "type": [
            "string",
            "null"
          ]
        },
        "college": {
          "type": [
            "string",
            "null"
          ]
        },
        "programme": {
          "anyOf": [
            {
              "type": "string",
              "enum": [
                "5_year",
                "3_year"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "year": {
          "anyOf": [
            {
              "type": "string",
              "enum": [
                "1",
                "2",
                "3",
                "4",
                "5"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "city": {
          "type": [
            "string",
            "null"
          ]
        },
        "consent": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "at": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
                },
                "policyVersion": {
                  "type": "string"
                },
                "current": {
                  "type": "boolean"
                }
              },
              "required": [
                "at",
                "policyVersion",
                "current"
              ],
              "additionalProperties": false
            },
            {
              "type": "null"
            }
          ]
        },
        "deletion": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "requestedAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
                },
                "dueAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
                },
                "reason": {
                  "type": "string",
                  "enum": [
                    "requested",
                    "plan_ended"
                  ]
                }
              },
              "required": [
                "requestedAt",
                "dueAt",
                "reason"
              ],
              "additionalProperties": false
            },
            {
              "type": "null"
            }
          ]
        },
        "createdAt": {
          "type": "string",
          "format": "date-time",
          "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
        }
      },
      "required": [
        "id",
        "email",
        "emailVerifiedAt",
        "name",
        "college",
        "programme",
        "year",
        "city",
        "consent",
        "deletion",
        "createdAt"
      ],
      "additionalProperties": false
    }
  },
  "required": [
    "ok",
    "profile"
  ],
  "additionalProperties": false
});

export const createProfileResponseContract = contract<CreateProfileResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "profile": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "email": {
          "type": "string"
        },
        "emailVerifiedAt": {
          "anyOf": [
            {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
            },
            {
              "type": "null"
            }
          ]
        },
        "name": {
          "type": [
            "string",
            "null"
          ]
        },
        "college": {
          "type": [
            "string",
            "null"
          ]
        },
        "programme": {
          "anyOf": [
            {
              "type": "string",
              "enum": [
                "5_year",
                "3_year"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "year": {
          "anyOf": [
            {
              "type": "string",
              "enum": [
                "1",
                "2",
                "3",
                "4",
                "5"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "city": {
          "type": [
            "string",
            "null"
          ]
        },
        "consent": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "at": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
                },
                "policyVersion": {
                  "type": "string"
                },
                "current": {
                  "type": "boolean"
                }
              },
              "required": [
                "at",
                "policyVersion",
                "current"
              ],
              "additionalProperties": false
            },
            {
              "type": "null"
            }
          ]
        },
        "deletion": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "requestedAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
                },
                "dueAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
                },
                "reason": {
                  "type": "string",
                  "enum": [
                    "requested",
                    "plan_ended"
                  ]
                }
              },
              "required": [
                "requestedAt",
                "dueAt",
                "reason"
              ],
              "additionalProperties": false
            },
            {
              "type": "null"
            }
          ]
        },
        "createdAt": {
          "type": "string",
          "format": "date-time",
          "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
        }
      },
      "required": [
        "id",
        "email",
        "emailVerifiedAt",
        "name",
        "college",
        "programme",
        "year",
        "city",
        "consent",
        "deletion",
        "createdAt"
      ],
      "additionalProperties": false
    },
    "access": {
      "type": "string",
      "enum": [
        "pending",
        "approved"
      ]
    }
  },
  "required": [
    "ok",
    "profile",
    "access"
  ],
  "additionalProperties": false
});

export const deletionResponseContract = contract<DeletionResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "deletion": {
      "anyOf": [
        {
          "type": "object",
          "properties": {
            "requestedAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
            },
            "dueAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
            }
          },
          "required": [
            "requestedAt",
            "dueAt"
          ],
          "additionalProperties": false
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "ok",
    "deletion"
  ],
  "additionalProperties": false
});

export const profileErrorContract = contract<ProfileError>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": false
    },
    "error": {
      "type": "string",
      "enum": [
        "invalid_request",
        "unauthenticated",
        "account_exists",
        "policy_outdated",
        "rate_limited",
        "server_misconfigured"
      ]
    },
    "message": {
      "type": "string"
    },
    "fields": {
      "type": "object",
      "propertyNames": {
        "type": "string"
      },
      "additionalProperties": {
        "type": "string"
      }
    },
    "currentPolicyVersion": {
      "type": "string"
    },
    "retryAfter": {
      "type": "integer",
      "exclusiveMinimum": 0,
      "maximum": 9007199254740991
    }
  },
  "required": [
    "ok",
    "error",
    "message"
  ],
  "additionalProperties": false
});

export const redeemFirmCodeResponseContract = contract<RedeemFirmCodeResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "planId": {
      "type": "string"
    },
    "period": {
      "type": "string",
      "pattern": "^\\d{4}-\\d{2}$"
    },
    "expiresAt": {
      "type": "string",
      "format": "date-time",
      "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
    },
    "seatsTaken": {
      "type": "integer",
      "minimum": 0,
      "maximum": 9007199254740991
    },
    "seatCap": {
      "type": "integer",
      "minimum": 0,
      "maximum": 9007199254740991
    }
  },
  "required": [
    "ok",
    "planId",
    "period",
    "expiresAt",
    "seatsTaken",
    "seatCap"
  ],
  "additionalProperties": false
});

export const codeErrorContract = contract<CodeError>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": false
    },
    "error": {
      "type": "string",
      "enum": [
        "invalid_request",
        "unauthenticated",
        "code_not_active",
        "already_redeemed",
        "seats_full",
        "already_on_a_plan",
        "rate_limited",
        "server_misconfigured"
      ]
    },
    "message": {
      "type": "string"
    },
    "retryAfter": {
      "type": "integer",
      "exclusiveMinimum": 0,
      "maximum": 9007199254740991
    }
  },
  "required": [
    "ok",
    "error",
    "message"
  ],
  "additionalProperties": false
});

export const myVoucherResponseContract = contract<MyVoucherResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "voucher": {
      "anyOf": [
        {
          "type": "object",
          "properties": {
            "code": {
              "type": "string"
            },
            "percent": {
              "type": "integer",
              "minimum": 1,
              "maximum": 100
            },
            "issuedAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
            },
            "expiresAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
            },
            "state": {
              "type": "string",
              "enum": [
                "live",
                "redeemed",
                "expired",
                "voided"
              ]
            },
            "redeemedAt": {
              "anyOf": [
                {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
                },
                {
                  "type": "null"
                }
              ]
            },
            "listPricePaise": {
              "type": "integer",
              "minimum": 0,
              "maximum": 9007199254740991
            },
            "payablePaise": {
              "type": "integer",
              "minimum": 0,
              "maximum": 9007199254740991
            }
          },
          "required": [
            "code",
            "percent",
            "issuedAt",
            "expiresAt",
            "state",
            "redeemedAt",
            "listPricePaise",
            "payablePaise"
          ],
          "additionalProperties": false
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "ok",
    "voucher"
  ],
  "additionalProperties": false
});

export const quoteResponseContract = contract<QuoteResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "plan": {
      "type": "string",
      "const": "annual"
    },
    "tier": {
      "type": "string",
      "enum": [
        "base",
        "premium",
        "elite"
      ]
    },
    "listDollars": {
      "type": "integer",
      "minimum": 0,
      "maximum": 9007199254740991
    },
    "discountDollars": {
      "type": "integer",
      "minimum": 0,
      "maximum": 9007199254740991
    },
    "amountDollars": {
      "type": "integer",
      "minimum": 0,
      "maximum": 9007199254740991
    },
    "fxRate": {
      "type": "number",
      "exclusiveMinimum": 0
    },
    "listPaise": {
      "type": "integer",
      "minimum": 0,
      "maximum": 9007199254740991
    },
    "discountPaise": {
      "type": "integer",
      "minimum": 0,
      "maximum": 9007199254740991
    },
    "amountPaise": {
      "type": "integer",
      "minimum": 0,
      "maximum": 9007199254740991
    },
    "percent": {
      "anyOf": [
        {
          "type": "integer",
          "minimum": 1,
          "maximum": 100
        },
        {
          "type": "null"
        }
      ]
    },
    "paymentsOpen": {
      "type": "boolean"
    }
  },
  "required": [
    "ok",
    "plan",
    "tier",
    "listPaise",
    "discountPaise",
    "amountPaise",
    "percent",
    "paymentsOpen"
  ],
  "additionalProperties": false
});

export const checkoutResponseContract = contract<CheckoutResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "checkoutId": {
      "type": "string"
    },
    "amountDollars": {
      "type": "integer",
      "minimum": 0,
      "maximum": 9007199254740991
    },
    "fxRate": {
      "type": "number",
      "exclusiveMinimum": 0
    },
    "amountPaise": {
      "type": "integer",
      "minimum": 0,
      "maximum": 9007199254740991
    },
    "provider": {
      "type": "string",
      "enum": [
        "development",
        "razorpay",
        "none"
      ]
    },
    "status": {
      "type": "string",
      "enum": [
        "open",
        "paid"
      ]
    }
  },
  "required": [
    "ok",
    "checkoutId",
    "amountPaise",
    "provider",
    "status"
  ],
  "additionalProperties": false
});

export const completeResponseContract = contract<CompleteResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "planId": {
      "type": "string"
    },
    "expiresAt": {
      "type": "string",
      "format": "date-time",
      "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
    }
  },
  "required": [
    "ok",
    "planId",
    "expiresAt"
  ],
  "additionalProperties": false
});

export const checkoutErrorContract = contract<CheckoutError>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": false
    },
    "error": {
      "type": "string",
      "enum": [
        "invalid_request",
        "unauthenticated",
        "voucher_not_found",
        "voucher_expired",
        "voucher_already_used",
        "voucher_voided",
        "voucher_not_yours",
        "voucher_not_for_tier",
        "already_on_a_plan",
        "payments_unavailable",
        "checkout_not_found",
        "checkout_expired",
        "rate_limited",
        "server_misconfigured"
      ]
    },
    "message": {
      "type": "string"
    },
    "retryAfter": {
      "type": "integer",
      "exclusiveMinimum": 0,
      "maximum": 9007199254740991
    }
  },
  "required": [
    "ok",
    "error",
    "message"
  ],
  "additionalProperties": false
});

export const pendingListResponseContract = contract<PendingListResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "pending": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string"
          },
          "email": {
            "type": "string"
          },
          "name": {
            "type": [
              "string",
              "null"
            ]
          },
          "college": {
            "type": [
              "string",
              "null"
            ]
          },
          "year": {
            "anyOf": [
              {
                "type": "string",
                "enum": [
                  "1",
                  "2",
                  "3",
                  "4",
                  "5"
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "city": {
            "type": [
              "string",
              "null"
            ]
          },
          "createdAt": {
            "type": "string",
            "format": "date-time",
            "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
          }
        },
        "required": [
          "id",
          "email",
          "name",
          "college",
          "year",
          "city",
          "createdAt"
        ],
        "additionalProperties": false
      }
    }
  },
  "required": [
    "ok",
    "pending"
  ],
  "additionalProperties": false
});

export const decideAccessResponseContract = contract<DecideAccessResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "id": {
      "type": "string"
    },
    "access": {
      "type": "string",
      "enum": [
        "approved",
        "declined"
      ]
    }
  },
  "required": [
    "ok",
    "id",
    "access"
  ],
  "additionalProperties": false
});

export const adminErrorContract = contract<AdminError>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": false
    },
    "error": {
      "type": "string",
      "enum": [
        "invalid_request",
        "not_admin",
        "not_pending"
      ]
    },
    "message": {
      "type": "string"
    }
  },
  "required": [
    "ok",
    "error",
    "message"
  ],
  "additionalProperties": false
});

export const billingResponseContract = contract<BillingResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "plan": {
      "anyOf": [
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "firm",
                "annual"
              ]
            },
            "tier": {
              "anyOf": [
                {
                  "type": "string",
                  "enum": [
                    "base",
                    "premium",
                    "elite"
                  ]
                },
                {
                  "type": "null"
                }
              ]
            },
            "startedAt": {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
            },
            "expiresAt": {
              "anyOf": [
                {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
                },
                {
                  "type": "null"
                }
              ]
            },
            "source": {
              "type": "string",
              "enum": [
                "internship",
                "firm_code",
                "purchase",
                "voucher"
              ]
            },
            "paidPaise": {
              "anyOf": [
                {
                  "type": "integer",
                  "minimum": 0,
                  "maximum": 9007199254740991
                },
                {
                  "type": "null"
                }
              ]
            }
          },
          "required": [
            "type",
            "tier",
            "startedAt",
            "expiresAt",
            "source",
            "paidPaise"
          ],
          "additionalProperties": false
        },
        {
          "type": "null"
        }
      ]
    },
    "invoices": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "number": {
            "type": "string"
          },
          "issuedAt": {
            "type": "string",
            "format": "date-time",
            "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
          },
          "description": {
            "type": "string"
          },
          "totalPaise": {
            "type": "integer",
            "minimum": 0,
            "maximum": 9007199254740991
          }
        },
        "required": [
          "number",
          "issuedAt",
          "description",
          "totalPaise"
        ],
        "additionalProperties": false
      }
    }
  },
  "required": [
    "ok",
    "plan",
    "invoices"
  ],
  "additionalProperties": false
});

export const recentsResponseContract = contract<RecentsResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "items": {
      "maxItems": 8,
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "kind": {
            "type": "string",
            "enum": [
              "document",
              "search"
            ]
          },
          "id": {
            "type": "string",
            "minLength": 1,
            "maxLength": 64
          },
          "title": {
            "type": "string",
            "minLength": 1,
            "maxLength": 200
          },
          "feature": {
            "type": "string",
            "enum": [
              "corporate-review",
              "paper-review",
              "knowledge",
              "writing",
              "plagiarism",
              "ai-detection",
              "citation",
              "publications"
            ]
          },
          "at": {
            "type": "string",
            "format": "date-time",
            "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
          }
        },
        "required": [
          "kind",
          "id",
          "title",
          "feature",
          "at"
        ],
        "additionalProperties": false
      }
    }
  },
  "required": [
    "ok",
    "items"
  ],
  "additionalProperties": false
});

export const historyResponseContract = contract<HistoryResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "items": {
      "maxItems": 30,
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "kind": {
            "type": "string",
            "enum": [
              "document",
              "search"
            ]
          },
          "id": {
            "type": "string",
            "minLength": 1,
            "maxLength": 64
          },
          "title": {
            "type": "string",
            "minLength": 1,
            "maxLength": 200
          },
          "feature": {
            "type": "string",
            "enum": [
              "corporate-review",
              "paper-review",
              "knowledge",
              "writing",
              "plagiarism",
              "ai-detection",
              "citation",
              "publications"
            ]
          },
          "at": {
            "type": "string",
            "format": "date-time",
            "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
          },
          "status": {
            "type": "string",
            "enum": [
              "done",
              "working",
              "failed"
            ]
          },
          "outcome": {
            "type": "string",
            "maxLength": 200
          },
          "credits": {
            "type": "integer",
            "minimum": 0,
            "maximum": 9007199254740991
          }
        },
        "required": [
          "kind",
          "id",
          "title",
          "feature",
          "at",
          "status",
          "outcome",
          "credits"
        ],
        "additionalProperties": false
      }
    },
    "next": {
      "type": [
        "string",
        "null"
      ]
    }
  },
  "required": [
    "ok",
    "items",
    "next"
  ],
  "additionalProperties": false
});

export const internListResponseContract = contract<InternListResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "interns": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "email": {
            "type": "string"
          },
          "startsAt": {
            "type": "string",
            "format": "date-time",
            "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
          },
          "expiresAt": {
            "type": "string",
            "format": "date-time",
            "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
          },
          "claimedAt": {
            "anyOf": [
              {
                "type": "string",
                "format": "date-time",
                "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
              },
              {
                "type": "null"
              }
            ]
          }
        },
        "required": [
          "email",
          "startsAt",
          "expiresAt",
          "claimedAt"
        ],
        "additionalProperties": false
      }
    }
  },
  "required": [
    "ok",
    "interns"
  ],
  "additionalProperties": false
});

export const provisionInternsResponseContract = contract<ProvisionInternsResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "added": {
      "type": "integer",
      "minimum": 0,
      "maximum": 9007199254740991
    },
    "already": {
      "type": "integer",
      "minimum": 0,
      "maximum": 9007199254740991
    }
  },
  "required": [
    "ok",
    "added",
    "already"
  ],
  "additionalProperties": false
});

export const intakeResponseContract = contract<IntakeResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "document": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "uploadId": {
          "type": "string"
        },
        "filename": {
          "type": "string"
        },
        "contentType": {
          "type": "string",
          "enum": [
            "application/pdf",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ]
        },
        "tool": {
          "type": "string",
          "enum": [
            "writing",
            "plagiarism",
            "ai-detection",
            "citation",
            "pipeline-check"
          ]
        },
        "words": {
          "type": "integer",
          "exclusiveMinimum": 0,
          "maximum": 9007199254740991
        },
        "pages": {
          "anyOf": [
            {
              "type": "integer",
              "exclusiveMinimum": 0,
              "maximum": 9007199254740991
            },
            {
              "type": "null"
            }
          ]
        },
        "status": {
          "type": "string",
          "enum": [
            "receiving",
            "ready"
          ]
        },
        "keep": {
          "type": "boolean"
        },
        "createdAt": {
          "type": "string",
          "format": "date-time",
          "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
        },
        "deleteAfter": {
          "anyOf": [
            {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
            },
            {
              "type": "null"
            }
          ]
        },
        "latestRun": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "id": {
                  "type": "string"
                },
                "tool": {
                  "type": "string",
                  "enum": [
                    "writing",
                    "plagiarism",
                    "ai-detection",
                    "citation",
                    "pipeline-check"
                  ]
                },
                "status": {
                  "type": "string",
                  "enum": [
                    "queued",
                    "running",
                    "done",
                    "failed"
                  ]
                },
                "credits": {
                  "type": "integer",
                  "minimum": 0,
                  "maximum": 9007199254740991
                },
                "charged": {
                  "type": "integer",
                  "minimum": 0,
                  "maximum": 9007199254740991
                },
                "createdAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
                },
                "finishedAt": {
                  "anyOf": [
                    {
                      "type": "string",
                      "format": "date-time",
                      "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "failure": {
                  "type": [
                    "string",
                    "null"
                  ]
                }
              },
              "required": [
                "id",
                "tool",
                "status",
                "credits",
                "charged",
                "createdAt",
                "finishedAt",
                "failure"
              ],
              "additionalProperties": false
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "id",
        "uploadId",
        "filename",
        "contentType",
        "tool",
        "words",
        "pages",
        "status",
        "keep",
        "createdAt",
        "deleteAfter",
        "latestRun"
      ],
      "additionalProperties": false
    },
    "uploadUrl": {
      "type": "string"
    },
    "expiresAt": {
      "type": "string",
      "format": "date-time",
      "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
    }
  },
  "required": [
    "ok",
    "document",
    "uploadUrl",
    "expiresAt"
  ],
  "additionalProperties": false
});

export const documentResponseContract = contract<DocumentResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "document": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "uploadId": {
          "type": "string"
        },
        "filename": {
          "type": "string"
        },
        "contentType": {
          "type": "string",
          "enum": [
            "application/pdf",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ]
        },
        "tool": {
          "type": "string",
          "enum": [
            "writing",
            "plagiarism",
            "ai-detection",
            "citation",
            "pipeline-check"
          ]
        },
        "words": {
          "type": "integer",
          "exclusiveMinimum": 0,
          "maximum": 9007199254740991
        },
        "pages": {
          "anyOf": [
            {
              "type": "integer",
              "exclusiveMinimum": 0,
              "maximum": 9007199254740991
            },
            {
              "type": "null"
            }
          ]
        },
        "status": {
          "type": "string",
          "enum": [
            "receiving",
            "ready"
          ]
        },
        "keep": {
          "type": "boolean"
        },
        "createdAt": {
          "type": "string",
          "format": "date-time",
          "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
        },
        "deleteAfter": {
          "anyOf": [
            {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
            },
            {
              "type": "null"
            }
          ]
        },
        "latestRun": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "id": {
                  "type": "string"
                },
                "tool": {
                  "type": "string",
                  "enum": [
                    "writing",
                    "plagiarism",
                    "ai-detection",
                    "citation",
                    "pipeline-check"
                  ]
                },
                "status": {
                  "type": "string",
                  "enum": [
                    "queued",
                    "running",
                    "done",
                    "failed"
                  ]
                },
                "credits": {
                  "type": "integer",
                  "minimum": 0,
                  "maximum": 9007199254740991
                },
                "charged": {
                  "type": "integer",
                  "minimum": 0,
                  "maximum": 9007199254740991
                },
                "createdAt": {
                  "type": "string",
                  "format": "date-time",
                  "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
                },
                "finishedAt": {
                  "anyOf": [
                    {
                      "type": "string",
                      "format": "date-time",
                      "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "failure": {
                  "type": [
                    "string",
                    "null"
                  ]
                }
              },
              "required": [
                "id",
                "tool",
                "status",
                "credits",
                "charged",
                "createdAt",
                "finishedAt",
                "failure"
              ],
              "additionalProperties": false
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "id",
        "uploadId",
        "filename",
        "contentType",
        "tool",
        "words",
        "pages",
        "status",
        "keep",
        "createdAt",
        "deleteAfter",
        "latestRun"
      ],
      "additionalProperties": false
    },
    "runs": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string"
          },
          "tool": {
            "type": "string",
            "enum": [
              "writing",
              "plagiarism",
              "ai-detection",
              "citation",
              "pipeline-check"
            ]
          },
          "status": {
            "type": "string",
            "enum": [
              "queued",
              "running",
              "done",
              "failed"
            ]
          },
          "credits": {
            "type": "integer",
            "minimum": 0,
            "maximum": 9007199254740991
          },
          "charged": {
            "type": "integer",
            "minimum": 0,
            "maximum": 9007199254740991
          },
          "createdAt": {
            "type": "string",
            "format": "date-time",
            "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
          },
          "finishedAt": {
            "anyOf": [
              {
                "type": "string",
                "format": "date-time",
                "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
              },
              {
                "type": "null"
              }
            ]
          },
          "failure": {
            "type": [
              "string",
              "null"
            ]
          }
        },
        "required": [
          "id",
          "tool",
          "status",
          "credits",
          "charged",
          "createdAt",
          "finishedAt",
          "failure"
        ],
        "additionalProperties": false
      }
    },
    "extract": {
      "type": "object",
      "properties": {
        "version": {
          "type": "number",
          "const": 1
        },
        "paragraphs": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "part": {
                "type": "string",
                "enum": [
                  "body",
                  "footnotes",
                  "endnotes"
                ]
              },
              "index": {
                "type": "integer",
                "minimum": 0,
                "maximum": 9007199254740991
              },
              "text": {
                "type": "string"
              },
              "sentences": {
                "type": "array",
                "items": {
                  "type": "array",
                  "items": {
                    "type": "integer",
                    "minimum": -9007199254740991,
                    "maximum": 9007199254740991
                  }
                }
              }
            },
            "required": [
              "part",
              "index",
              "text",
              "sentences"
            ],
            "additionalProperties": false
          }
        },
        "words": {
          "type": "integer",
          "minimum": 0,
          "maximum": 9007199254740991
        },
        "pages": {
          "anyOf": [
            {
              "type": "integer",
              "exclusiveMinimum": 0,
              "maximum": 9007199254740991
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "version",
        "paragraphs",
        "words",
        "pages"
      ],
      "additionalProperties": false
    }
  },
  "required": [
    "ok",
    "document",
    "runs",
    "extract"
  ],
  "additionalProperties": false
});

export const runResponseContract = contract<RunResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "run": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "tool": {
          "type": "string",
          "enum": [
            "writing",
            "plagiarism",
            "ai-detection",
            "citation",
            "pipeline-check"
          ]
        },
        "status": {
          "type": "string",
          "enum": [
            "queued",
            "running",
            "done",
            "failed"
          ]
        },
        "credits": {
          "type": "integer",
          "minimum": 0,
          "maximum": 9007199254740991
        },
        "charged": {
          "type": "integer",
          "minimum": 0,
          "maximum": 9007199254740991
        },
        "createdAt": {
          "type": "string",
          "format": "date-time",
          "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
        },
        "finishedAt": {
          "anyOf": [
            {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
            },
            {
              "type": "null"
            }
          ]
        },
        "failure": {
          "type": [
            "string",
            "null"
          ]
        }
      },
      "required": [
        "id",
        "tool",
        "status",
        "credits",
        "charged",
        "createdAt",
        "finishedAt",
        "failure"
      ],
      "additionalProperties": false
    },
    "result": {
      "anyOf": [
        {
          "type": "object",
          "properties": {
            "corrections": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "part": {
                    "type": "string",
                    "enum": [
                      "body",
                      "footnotes",
                      "endnotes"
                    ]
                  },
                  "paragraph": {
                    "type": "integer",
                    "minimum": 0,
                    "maximum": 9007199254740991
                  },
                  "start": {
                    "type": "integer",
                    "minimum": 0,
                    "maximum": 9007199254740991
                  },
                  "end": {
                    "type": "integer",
                    "minimum": 0,
                    "maximum": 9007199254740991
                  },
                  "original": {
                    "type": "string"
                  },
                  "replacement": {
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "comment": {
                    "type": "string",
                    "maxLength": 2000
                  },
                  "kind": {
                    "type": "string",
                    "enum": [
                      "grammar",
                      "spelling",
                      "punctuation",
                      "consistency",
                      "clarity",
                      "flow"
                    ]
                  }
                },
                "required": [
                  "part",
                  "paragraph",
                  "start",
                  "end",
                  "original",
                  "replacement"
                ],
                "additionalProperties": false
              }
            },
            "withheld": {
              "type": "object",
              "properties": {
                "protected": {
                  "type": "integer",
                  "minimum": 0,
                  "maximum": 9007199254740991
                },
                "meaning": {
                  "type": "integer",
                  "minimum": 0,
                  "maximum": 9007199254740991
                },
                "overlap": {
                  "type": "integer",
                  "minimum": 0,
                  "maximum": 9007199254740991
                }
              },
              "required": [
                "protected",
                "meaning",
                "overlap"
              ],
              "additionalProperties": false
            }
          },
          "required": [
            "corrections"
          ],
          "additionalProperties": false
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "ok",
    "run",
    "result"
  ],
  "additionalProperties": false
});

export const documentErrorContract = contract<DocumentError>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": false
    },
    "error": {
      "type": "string",
      "enum": [
        "invalid_request",
        "unauthenticated",
        "too_many_words",
        "no_text",
        "tool_unavailable",
        "type_not_allowed",
        "too_large",
        "storage_full",
        "not_found",
        "rate_limited",
        "storage_unavailable",
        "no_credits"
      ]
    },
    "message": {
      "type": "string"
    },
    "fields": {
      "type": "object",
      "propertyNames": {
        "type": "string"
      },
      "additionalProperties": {
        "type": "string"
      }
    },
    "words": {
      "type": "integer",
      "minimum": -9007199254740991,
      "maximum": 9007199254740991
    },
    "retryAfter": {
      "type": "integer",
      "exclusiveMinimum": 0,
      "maximum": 9007199254740991
    }
  },
  "required": [
    "ok",
    "error",
    "message"
  ],
  "additionalProperties": false
});

export const aiSpendResponseContract = contract<AiSpendResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "days": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "day": {
            "type": "string"
          },
          "tool": {
            "type": "string",
            "enum": [
              "writing.refine",
              "writing.meaning",
              "citation.parse",
              "plagiarism.embed",
              "plagiarism.confirm",
              "detection.judge",
              "course.lesson",
              "portal.assignment"
            ]
          },
          "provider": {
            "type": "string",
            "enum": [
              "workers-ai",
              "anthropic",
              "google",
              "openai"
            ]
          },
          "model": {
            "type": "string"
          },
          "calls": {
            "type": "integer",
            "minimum": 0,
            "maximum": 9007199254740991
          },
          "failed": {
            "type": "integer",
            "minimum": 0,
            "maximum": 9007199254740991
          },
          "tokensIn": {
            "type": "integer",
            "minimum": 0,
            "maximum": 9007199254740991
          },
          "tokensOut": {
            "type": "integer",
            "minimum": 0,
            "maximum": 9007199254740991
          },
          "neurons": {
            "type": "number",
            "minimum": 0
          },
          "listMicrousd": {
            "type": "integer",
            "minimum": 0,
            "maximum": 9007199254740991
          },
          "billedMicrousd": {
            "type": "integer",
            "minimum": 0,
            "maximum": 9007199254740991
          }
        },
        "required": [
          "day",
          "tool",
          "provider",
          "model",
          "calls",
          "failed",
          "tokensIn",
          "tokensOut",
          "neurons",
          "listMicrousd",
          "billedMicrousd"
        ],
        "additionalProperties": false
      }
    },
    "month": {
      "type": "object",
      "properties": {
        "month": {
          "type": "string"
        },
        "billedPaise": {
          "type": "integer",
          "minimum": 0,
          "maximum": 9007199254740991
        },
        "listPaise": {
          "type": "integer",
          "minimum": 0,
          "maximum": 9007199254740991
        },
        "thresholdInr": {
          "type": "integer",
          "exclusiveMinimum": 0,
          "maximum": 9007199254740991
        },
        "alertedAt": {
          "anyOf": [
            {
              "type": "string",
              "format": "date-time",
              "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
            },
            {
              "type": "null"
            }
          ]
        },
        "fxRate": {
          "type": "number",
          "exclusiveMinimum": 0
        }
      },
      "required": [
        "month",
        "billedPaise",
        "listPaise",
        "thresholdInr",
        "alertedAt",
        "fxRate"
      ],
      "additionalProperties": false
    },
    "neuronsToday": {
      "type": "number",
      "minimum": 0
    },
    "neuronCeiling": {
      "type": "integer",
      "exclusiveMinimum": 0,
      "maximum": 9007199254740991
    },
    "tools": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "tool": {
            "type": "string",
            "enum": [
              "writing.refine",
              "writing.meaning",
              "citation.parse",
              "plagiarism.embed",
              "plagiarism.confirm",
              "detection.judge",
              "course.lesson",
              "portal.assignment"
            ]
          },
          "feature": {
            "type": "string"
          },
          "ships": {
            "type": "integer",
            "exclusiveMinimum": 0,
            "maximum": 9007199254740991
          },
          "kind": {
            "type": "string",
            "enum": [
              "chat",
              "embed"
            ]
          },
          "primary": {
            "type": "string"
          },
          "standby": {
            "type": "string"
          },
          "source": {
            "type": "string",
            "enum": [
              "default",
              "setting"
            ]
          }
        },
        "required": [
          "tool",
          "feature",
          "ships",
          "kind",
          "primary",
          "standby",
          "source"
        ],
        "additionalProperties": false
      }
    }
  },
  "required": [
    "ok",
    "days",
    "month",
    "neuronsToday",
    "neuronCeiling",
    "tools"
  ],
  "additionalProperties": false
});

export const aiSettingResponseContract = contract<AiSettingResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    }
  },
  "required": [
    "ok"
  ],
  "additionalProperties": false
});

export const removeInternsResponseContract = contract<RemoveInternsResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "removed": {
      "type": "integer",
      "minimum": 0,
      "maximum": 9007199254740991
    },
    "eliteEnded": {
      "type": "integer",
      "minimum": 0,
      "maximum": 9007199254740991
    },
    "notListed": {
      "type": "integer",
      "minimum": 0,
      "maximum": 9007199254740991
    }
  },
  "required": [
    "ok",
    "removed",
    "eliteEnded",
    "notListed"
  ],
  "additionalProperties": false
});

export const knowledgeSearchResponseContract = contract<KnowledgeSearchResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "search": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "minLength": 1
        },
        "kind": {
          "type": "string",
          "enum": [
            "topic",
            "related"
          ]
        },
        "topic": {
          "type": "string",
          "minLength": 1
        },
        "status": {
          "type": "string",
          "enum": [
            "done",
            "failed"
          ]
        },
        "charged": {
          "type": "integer",
          "minimum": 0,
          "maximum": 9007199254740991
        },
        "at": {
          "type": "string",
          "format": "date-time",
          "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
        },
        "works": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "key": {
                "type": "string",
                "minLength": 1,
                "maxLength": 200
              },
              "doi": {
                "type": [
                  "string",
                  "null"
                ]
              },
              "title": {
                "type": "string",
                "minLength": 1
              },
              "authors": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              },
              "year": {
                "anyOf": [
                  {
                    "type": "integer",
                    "minimum": -9007199254740991,
                    "maximum": 9007199254740991
                  },
                  {
                    "type": "null"
                  }
                ]
              },
              "kind": {
                "type": "string",
                "enum": [
                  "article",
                  "book",
                  "chapter"
                ]
              },
              "venue": {
                "type": "object",
                "properties": {
                  "name": {
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "issn": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "isbn": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "publisher": {
                    "type": [
                      "string",
                      "null"
                    ]
                  }
                },
                "required": [
                  "name",
                  "issn",
                  "isbn",
                  "publisher"
                ],
                "additionalProperties": false
              },
              "preprint": {
                "type": "boolean"
              },
              "description": {
                "type": [
                  "string",
                  "null"
                ]
              },
              "citedBy": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "count": {
                        "type": "integer",
                        "minimum": 0,
                        "maximum": 9007199254740991
                      },
                      "index": {
                        "type": "string"
                      }
                    },
                    "required": [
                      "count",
                      "index"
                    ],
                    "additionalProperties": false
                  },
                  {
                    "type": "null"
                  }
                ]
              },
              "link": {
                "type": "string"
              },
              "openUrl": {
                "type": [
                  "string",
                  "null"
                ]
              },
              "readable": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "pdfUrl": {
                        "type": "string",
                        "format": "uri"
                      },
                      "licence": {
                        "type": "string",
                        "enum": [
                          "cc-by",
                          "cc-by-sa",
                          "cc-by-nd",
                          "cc0",
                          "public-domain"
                        ]
                      },
                      "licenceUrl": {
                        "type": "string"
                      },
                      "confirmedBy": {
                        "type": "string",
                        "enum": [
                          "crossref",
                          "publisher-page"
                        ]
                      }
                    },
                    "required": [
                      "pdfUrl",
                      "licence"
                    ],
                    "additionalProperties": false
                  },
                  {
                    "type": "null"
                  }
                ]
              },
              "openalexId": {
                "type": [
                  "string",
                  "null"
                ]
              },
              "standing": {
                "type": "string",
                "enum": [
                  "core",
                  "doaj",
                  "academic",
                  "recorded"
                ]
              },
              "openVersion": {
                "anyOf": [
                  {
                    "type": "string",
                    "enum": [
                      "published",
                      "accepted",
                      "submitted"
                    ]
                  },
                  {
                    "type": "null"
                  }
                ]
              },
              "versions": {
                "type": "array",
                "items": {
                  "type": "object",
                  "properties": {
                    "url": {
                      "type": "string",
                      "pattern": "^https?:\\/\\/"
                    },
                    "kind": {
                      "type": "string",
                      "enum": [
                        "pdf",
                        "page"
                      ]
                    },
                    "holder": {
                      "type": [
                        "string",
                        "null"
                      ]
                    },
                    "holderType": {
                      "type": [
                        "string",
                        "null"
                      ]
                    },
                    "version": {
                      "anyOf": [
                        {
                          "type": "string",
                          "enum": [
                            "published",
                            "accepted",
                            "submitted"
                          ]
                        },
                        {
                          "type": "null"
                        }
                      ]
                    }
                  },
                  "required": [
                    "url",
                    "kind",
                    "holder",
                    "holderType",
                    "version"
                  ],
                  "additionalProperties": false
                }
              }
            },
            "required": [
              "key",
              "doi",
              "title",
              "authors",
              "year",
              "kind",
              "venue",
              "preprint",
              "description",
              "citedBy",
              "link",
              "openUrl",
              "openalexId"
            ],
            "additionalProperties": false
          }
        },
        "more": {
          "type": "boolean"
        },
        "found": {
          "type": "integer",
          "minimum": 0,
          "maximum": 9007199254740991
        }
      },
      "required": [
        "id",
        "kind",
        "topic",
        "status",
        "charged",
        "at",
        "works",
        "more"
      ],
      "additionalProperties": false
    }
  },
  "required": [
    "ok",
    "search"
  ],
  "additionalProperties": false
});

export const knowledgeErrorContract = contract<KnowledgeError>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": false
    },
    "error": {
      "type": "string",
      "enum": [
        "invalid_request",
        "unauthenticated",
        "credits_needed",
        "search_failed",
        "no_related",
        "related_paused",
        "not_found"
      ]
    },
    "message": {
      "type": "string"
    },
    "price": {
      "type": "integer",
      "minimum": -9007199254740991,
      "maximum": 9007199254740991
    },
    "free": {
      "type": "boolean"
    },
    "resumesAt": {
      "type": "string",
      "format": "date-time",
      "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
    }
  },
  "required": [
    "ok",
    "error",
    "message"
  ],
  "additionalProperties": false
});

export const knowledgeVersionsResponseContract = contract<KnowledgeVersionsResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "versions": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "url": {
            "type": "string",
            "pattern": "^https?:\\/\\/"
          },
          "kind": {
            "type": "string",
            "enum": [
              "pdf",
              "page"
            ]
          },
          "holder": {
            "type": [
              "string",
              "null"
            ]
          },
          "holderType": {
            "type": [
              "string",
              "null"
            ]
          },
          "version": {
            "anyOf": [
              {
                "type": "string",
                "enum": [
                  "published",
                  "accepted",
                  "submitted"
                ]
              },
              {
                "type": "null"
              }
            ]
          },
          "opens": {
            "type": "boolean"
          }
        },
        "required": [
          "url",
          "kind",
          "holder",
          "holderType",
          "version",
          "opens"
        ],
        "additionalProperties": false
      }
    }
  },
  "required": [
    "ok",
    "versions"
  ],
  "additionalProperties": false
});

export const citeResponseContract = contract<CiteResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "source": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "minLength": 1
        },
        "workKey": {
          "type": "string"
        },
        "title": {
          "type": "string"
        },
        "style": {
          "type": "string",
          "enum": [
            "oscola",
            "bluebook",
            "ili",
            "alwd",
            "aglc",
            "mcgill",
            "nzlsg",
            "apa",
            "mla",
            "chicago",
            "chicago-ad",
            "turabian",
            "harvard",
            "harvard-aru",
            "asa",
            "apsa",
            "aaa",
            "mhra",
            "sbl",
            "ieee",
            "vancouver",
            "ama",
            "acs",
            "cse-cs",
            "cse-ny",
            "nature",
            "science",
            "cell",
            "acm",
            "aip",
            "aps",
            "asce",
            "elsevier-harvard",
            "springer",
            "iso690",
            "gbt7714",
            "abnt"
          ]
        },
        "completeness": {
          "type": "string",
          "enum": [
            "complete",
            "partial"
          ]
        },
        "record": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "type": {
              "type": "string"
            },
            "title": {
              "type": "string"
            },
            "author": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "family": {
                    "type": "string"
                  },
                  "given": {
                    "type": "string"
                  },
                  "literal": {
                    "type": "string"
                  },
                  "suffix": {
                    "type": "string"
                  },
                  "non-dropping-particle": {
                    "type": "string"
                  },
                  "dropping-particle": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            },
            "editor": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "family": {
                    "type": "string"
                  },
                  "given": {
                    "type": "string"
                  },
                  "literal": {
                    "type": "string"
                  },
                  "suffix": {
                    "type": "string"
                  },
                  "non-dropping-particle": {
                    "type": "string"
                  },
                  "dropping-particle": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            },
            "container-title": {
              "type": "string"
            },
            "container-title-short": {
              "type": "string"
            },
            "collection-title": {
              "type": "string"
            },
            "volume": {
              "type": "string"
            },
            "issue": {
              "type": "string"
            },
            "page": {
              "type": "string"
            },
            "number": {
              "type": "string"
            },
            "edition": {
              "type": "string"
            },
            "publisher": {
              "type": "string"
            },
            "publisher-place": {
              "type": "string"
            },
            "issued": {
              "type": "object",
              "properties": {
                "date-parts": {
                  "type": "array",
                  "items": {
                    "type": "array",
                    "items": {
                      "type": "integer",
                      "minimum": -9007199254740991,
                      "maximum": 9007199254740991
                    }
                  }
                }
              },
              "required": [
                "date-parts"
              ],
              "additionalProperties": false
            },
            "DOI": {
              "type": "string"
            },
            "ISBN": {
              "type": "string"
            },
            "ISSN": {
              "type": "string"
            },
            "URL": {
              "type": "string"
            }
          },
          "required": [
            "id",
            "type"
          ],
          "additionalProperties": false
        },
        "searchId": {
          "type": [
            "string",
            "null"
          ]
        },
        "at": {
          "type": "string",
          "format": "date-time",
          "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
        }
      },
      "required": [
        "id",
        "workKey",
        "title",
        "style",
        "completeness",
        "record",
        "searchId",
        "at"
      ],
      "additionalProperties": false
    }
  },
  "required": [
    "ok",
    "source"
  ],
  "additionalProperties": false
});

export const citationSourcesResponseContract = contract<CitationSourcesResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "style": {
      "type": "string",
      "enum": [
        "oscola",
        "bluebook",
        "ili",
        "alwd",
        "aglc",
        "mcgill",
        "nzlsg",
        "apa",
        "mla",
        "chicago",
        "chicago-ad",
        "turabian",
        "harvard",
        "harvard-aru",
        "asa",
        "apsa",
        "aaa",
        "mhra",
        "sbl",
        "ieee",
        "vancouver",
        "ama",
        "acs",
        "cse-cs",
        "cse-ny",
        "nature",
        "science",
        "cell",
        "acm",
        "aip",
        "aps",
        "asce",
        "elsevier-harvard",
        "springer",
        "iso690",
        "gbt7714",
        "abnt"
      ]
    },
    "items": {
      "maxItems": 100,
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "minLength": 1
          },
          "workKey": {
            "type": "string"
          },
          "title": {
            "type": "string"
          },
          "style": {
            "type": "string",
            "enum": [
              "oscola",
              "bluebook",
              "ili",
              "alwd",
              "aglc",
              "mcgill",
              "nzlsg",
              "apa",
              "mla",
              "chicago",
              "chicago-ad",
              "turabian",
              "harvard",
              "harvard-aru",
              "asa",
              "apsa",
              "aaa",
              "mhra",
              "sbl",
              "ieee",
              "vancouver",
              "ama",
              "acs",
              "cse-cs",
              "cse-ny",
              "nature",
              "science",
              "cell",
              "acm",
              "aip",
              "aps",
              "asce",
              "elsevier-harvard",
              "springer",
              "iso690",
              "gbt7714",
              "abnt"
            ]
          },
          "completeness": {
            "type": "string",
            "enum": [
              "complete",
              "partial"
            ]
          },
          "record": {
            "type": "object",
            "properties": {
              "id": {
                "type": "string"
              },
              "type": {
                "type": "string"
              },
              "title": {
                "type": "string"
              },
              "author": {
                "type": "array",
                "items": {
                  "type": "object",
                  "properties": {
                    "family": {
                      "type": "string"
                    },
                    "given": {
                      "type": "string"
                    },
                    "literal": {
                      "type": "string"
                    },
                    "suffix": {
                      "type": "string"
                    },
                    "non-dropping-particle": {
                      "type": "string"
                    },
                    "dropping-particle": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "editor": {
                "type": "array",
                "items": {
                  "type": "object",
                  "properties": {
                    "family": {
                      "type": "string"
                    },
                    "given": {
                      "type": "string"
                    },
                    "literal": {
                      "type": "string"
                    },
                    "suffix": {
                      "type": "string"
                    },
                    "non-dropping-particle": {
                      "type": "string"
                    },
                    "dropping-particle": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "container-title": {
                "type": "string"
              },
              "container-title-short": {
                "type": "string"
              },
              "collection-title": {
                "type": "string"
              },
              "volume": {
                "type": "string"
              },
              "issue": {
                "type": "string"
              },
              "page": {
                "type": "string"
              },
              "number": {
                "type": "string"
              },
              "edition": {
                "type": "string"
              },
              "publisher": {
                "type": "string"
              },
              "publisher-place": {
                "type": "string"
              },
              "issued": {
                "type": "object",
                "properties": {
                  "date-parts": {
                    "type": "array",
                    "items": {
                      "type": "array",
                      "items": {
                        "type": "integer",
                        "minimum": -9007199254740991,
                        "maximum": 9007199254740991
                      }
                    }
                  }
                },
                "required": [
                  "date-parts"
                ],
                "additionalProperties": false
              },
              "DOI": {
                "type": "string"
              },
              "ISBN": {
                "type": "string"
              },
              "ISSN": {
                "type": "string"
              },
              "URL": {
                "type": "string"
              }
            },
            "required": [
              "id",
              "type"
            ],
            "additionalProperties": false
          },
          "searchId": {
            "type": [
              "string",
              "null"
            ]
          },
          "at": {
            "type": "string",
            "format": "date-time",
            "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
          }
        },
        "required": [
          "id",
          "workKey",
          "title",
          "style",
          "completeness",
          "record",
          "searchId",
          "at"
        ],
        "additionalProperties": false
      }
    }
  },
  "required": [
    "ok",
    "style",
    "items"
  ],
  "additionalProperties": false
});

export const knowledgeHistoryResponseContract = contract<KnowledgeHistoryResponse>({
  "type": "object",
  "properties": {
    "ok": {
      "type": "boolean",
      "const": true
    },
    "items": {
      "maxItems": 200,
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "id": {
            "type": "string",
            "minLength": 1
          },
          "kind": {
            "type": "string",
            "enum": [
              "topic",
              "related"
            ]
          },
          "topic": {
            "type": "string",
            "minLength": 1
          },
          "at": {
            "type": "string",
            "format": "date-time",
            "pattern": "^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$"
          },
          "results": {
            "type": "integer",
            "minimum": 0,
            "maximum": 9007199254740991
          }
        },
        "required": [
          "id",
          "kind",
          "topic",
          "at",
          "results"
        ],
        "additionalProperties": false
      }
    }
  },
  "required": [
    "ok",
    "items"
  ],
  "additionalProperties": false
});
